import React from 'react';
import { Section } from './Shared';
export const ValueStack = () => {
  const items = [{
    name: 'Tomo Principal REFLEXO-PRO',
    value: '$40.000 ARS'
  }, {
    name: 'Bonus 1: El Legajo de Campo',
    value: '$12.000 ARS'
  }, {
    name: 'Bonus 2: El Control de Abastecimiento',
    value: '$10.000 ARS'
  }];
  return <Section className="max-w-3xl" data-id="element-281">
      <div className="text-center mb-10" data-id="element-282">
        <h2 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-283">
          💰 EL VALOR REAL DE ESTE SISTEMA
        </h2>
      </div>

      <div className="glass-panel rounded-3xl overflow-hidden border-brand-pink/30 bg-white/80" data-id="element-284">
        <div className="p-6 md:p-8 space-y-4" data-id="element-285">
          {items.map((item, i) => <div key={i} className="flex justify-between items-center border-b border-brand-pink/20 pb-4 last:border-0 last:pb-0" data-id="element-286">
              <span className="text-brand-text/90 font-medium text-[14px] md:text-base" data-id="element-287">
                {item.name}
              </span>
              <span className="text-brand-text/60 line-through text-[14px] md:text-base" data-id="element-288">
                {item.value}
              </span>
            </div>)}
        </div>

        <div className="bg-brand-surfaceLight/50 p-6 md:p-8 border-t border-brand-pink/30" data-id="element-289">
          <div className="flex justify-between items-center mb-2" data-id="element-290">
            <span className="font-serif font-bold text-lg text-brand-text" data-id="element-291">
              Valor total del sistema
            </span>
            <span className="font-serif font-bold text-lg text-brand-text/60 line-through" data-id="element-292">
              $62.000 ARS
            </span>
          </div>
          <div className="flex justify-between items-center mt-4" data-id="element-293">
            <span className="font-serif font-bold text-2xl text-brand-rose" data-id="element-294">
              Tu inversión hoy
            </span>
            <span className="font-serif font-bold text-3xl text-brand-rose" data-id="element-295">
              $15.990 ARS
            </span>
          </div>
        </div>
      </div>
    </Section>;
};